// extracted by mini-css-extract-plugin
export default {"Description":"_Description--edzmU","TooltipMessage":"_TooltipMessage--imJNJ","Badge":"_Badge--LoGkA","Icon":"_Icon--Upt5R","Internal":"_Internal--xGH6v","Public":"_Public--qebhM"};